export function getBrowserName() {
  let navigtr = navigator.userAgent;
  let userBrowserNm = navigator.appName;
  let nameOffset, vrOfSet;

  if ((vrOfSet = navigtr.indexOf("OPR/")) != -1) {
    userBrowserNm = "Opera";
  } else if ((vrOfSet = navigtr.indexOf("Opera")) != -1) {
    userBrowserNm = "Opera";
  } else if ((vrOfSet = navigtr.indexOf("MSIE")) != -1) {
    userBrowserNm = "Microsoft Internet Explorer";
  } else if ((vrOfSet = navigtr.indexOf("Chrome")) != -1) {
    userBrowserNm = "Chrome";
  } else if ((vrOfSet = navigtr.indexOf("Safari")) != -1) {
    userBrowserNm = "Safari";
  } else if ((vrOfSet = navigtr.indexOf("Firefox")) != -1) {
    userBrowserNm = "Firefox";
  } else if (
    (nameOffset = navigtr.lastIndexOf(" ") + 1) <
    (vrOfSet = navigtr.lastIndexOf("/"))
  ) {
    userBrowserNm = navigtr.substring(nameOffset, vrOfSet);
    if (userBrowserNm.toLowerCase() == userBrowserNm.toUpperCase()) {
      userBrowserNm = navigator.appName;
    }
  }

  return userBrowserNm;
}
